import React from "react";
import { NOT_ADVICE } from "@/components/Disclaimers";

export default function Privacy() {
  return (
    <div className="mx-auto max-w-3xl px-4 sm:px-6 lg:px-8 py-12">
      <h1 className="font-display text-3xl font-semibold text-[hsl(var(--atlas-navy))]">Privacy</h1>
      <div className="mt-4 space-y-4 text-sm text-[hsl(var(--atlas-slate))]">
        <p>Your nationality and ancestry details are personal data. We store the minimum needed to generate and retrieve your report.</p>
        <ul className="list-disc pl-5 space-y-1">
          <li>We do not sell your data or share it with governments, developers, funds, law firms, or agents.</li>
          <li>Your email is used only to give you permanent access to reports you purchase.</li>
          <li>You can request deletion of your data at any time.</li>
        </ul>
        <p className="text-muted-foreground">{NOT_ADVICE}</p>
      </div>
    </div>
  );
}
